import React, { useState } from "react";
import { FaImage, FaVideo, FaFilePdf, FaRegFileAudio, FaFileAlt } from "react-icons/fa";
import { TiDeleteOutline } from "react-icons/ti";
import "./fileList.scss";

export default function FileList({ files, handleDelete, filesVisible = 5 }) {
    const [visibleFiles, setVisibleFiles] = useState(filesVisible);

    const handleShowMore = () => {
        setVisibleFiles((prevVisibleFiles) => prevVisibleFiles + 5);
    };

    const openFile = (file) => {
        console.log(file)
        if(file instanceof File) {
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
        }else {
            window.open(file, '_blank');
        }
    };

    const getFileIcon = (file) => {
        const extension = file.split(".").pop().toLowerCase();
        switch (extension) {
            case "jpg":
            case "jpeg":
            case "png":
            case "gif":
                return <FaImage />;
            case "mp4":
            case "mov":
            case "avi":
                return <FaVideo />;
            case "pdf":
                return <FaFilePdf />;
            case "mp3":
            case "wav":
            case "ogg":
                return <FaRegFileAudio />;
            default:
                return <FaFileAlt />;
        }
    };

    const formatFileName = (file) => {        
        let fileName = "";

        if(file instanceof File) {
            fileName = file.name
        } else {
            const arrayFile = file.split("/")
            fileName = arrayFile[arrayFile.length-1]
        }

        return fileName
    }

    return (
        <div className="file-list">
            {files.slice(0, visibleFiles).map((file, index) => (
                <div className="file-list__item" key={index}>
                    <span className="file-list__icon">{getFileIcon(formatFileName(file))}</span>
                    <span className="file-list__name" onClick={() => openFile(file)}>
                        {formatFileName(file)}
                    </span>
                    {handleDelete && <TiDeleteOutline
                        className="file-list__delete-icon"
                        onClick={() => handleDelete(file)}
                    />}
                </div>
            ))}
            {visibleFiles < files.length && (
                <button className="file-list__button" onClick={handleShowMore}>
                    Ver más archivos
                </button>
            )}
        </div>
        
    );
}
